import {
  FETCH_ALL_BATCH_INGREDIENCES,
  RESET_BATCH_INGREDIENCES,
  REMOVE_BATCH_INGREDIENCE,
  ADD_BATCH_INGREDIENCE,
  UPDATE_BATCH_INGREDIENCE,
} from '../../mutation-types';

export default {
  [RESET_BATCH_INGREDIENCES](state) {
    state.all = [];
  },

  [FETCH_ALL_BATCH_INGREDIENCES](state, batchIngrediences) {
    state.all = batchIngrediences;
  },

  [REMOVE_BATCH_INGREDIENCE](state, id) {
    state.all = state.all.filter(p => p.id !== id);
  },

  [ADD_BATCH_INGREDIENCE](state, batchIngredience) {
    state.all.push(batchIngredience);
  },

  [UPDATE_BATCH_INGREDIENCE](state, { batchIngredience, id }) {
    state.all.map((p) => {
      if (p.id.toString() === id.toString()) {
        Object.keys(batchIngredience).map((k) => {
          p[k] = batchIngredience[k];
          return k;
        });
      }
      return p;
    });
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/batchIngredience/mutations.js